<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    <g>
  <circle cx="12" cy="32" r="8" stroke-width="0">
    <animate attributeName="fill-opacity" dur="1000ms" values=".9;.8;.8;.9;.95;1;.95;.9" repeatCount="indefinite" />
    <animate attributeName="r" dur="1000ms" values="5;5;6;7;8;7;6;5" repeatCount="indefinite" />
  </circle>
  <circle cx="32" cy="32" r="8" stroke-width="0">
    <animate attributeName="fill-opacity" dur="1000ms" values=".9;.8;.8;.9;.95;1;.95;.9" repeatCount="indefinite" />
    <animate attributeName="r" dur="1000ms" values="6;5;5;6;7;8;7;6" repeatCount="indefinite" />
  </circle>
  <circle cx="52" cy="32" r="8" stroke-width="0">
    <animate attributeName="fill-opacity" dur="1000ms" values=".9;.8;.8;.9;.95;1;.95;.9" repeatCount="indefinite" />
    <animate attributeName="r" dur="1000ms" values="7;6;5;5;6;7;8;7" repeatCount="indefinite" />
  </circle>
</g>
  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: 'PtcyLoaderDots',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 64 64',
    },
  },
};
</script>

<style scoped>
  
</style>